import _JSXStyle from "styled-jsx/style";
import { useConfig } from '@dhis2/app-runtime';
import PropTypes from 'prop-types';
import React from 'react';
export const useAvatarImgSrc = avatarId => {
  const {
    baseUrl
  } = useConfig();
  return avatarId ? [baseUrl, 'api/fileResources', avatarId, 'data'].filter(part => !!part).map(part => part.replace(/^\/+|\/+$/g, '')).join('/') : null;
};
export const ImageAvatar = _ref => {
  let {
    avatarId,
    dataTest
  } = _ref;
  const src = useAvatarImgSrc(avatarId);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: "user avatar",
    "data-test": dataTest,
    className: "jsx-3329187909"
  }), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "3329187909"
  }, ["img.jsx-3329187909{width:100%;height:100%;border-radius:50%;object-fit:cover;}"]));
};
ImageAvatar.propTypes = {
  avatarId: PropTypes.string.isRequired,
  dataTest: PropTypes.string
};